export function searchFilter<T>(
  item: T extends { [key: string]: any } ? T : { [key: string]: string },
  itemKey: keyof typeof item,
  search: string
) {
  const searchValue = search.toLowerCase()
  return item[itemKey]?.toLowerCase()?.includes(searchValue)
}
